import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Landing from "./pages/Landing";
import OtherServices from "./pages/OtherServices";
import PageTypesPricing from "./pages/PageTypesPricing";
import PortfolioPaginas from "./pages/PortfolioPaginas";
import { Toaster } from "sonner";
import ChatBubble from "./components/nexo/ChatBubble";
import { NEXO_ENABLED } from "./config/bdk";

// Route changes don't reset scroll position on their own (no hash target =
// browser keeps wherever the previous page was scrolled to).
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <HelmetProvider>
      <div className="App font-body bg-white text-[#101010]">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/otros-servicios" element={<OtherServices />} />
            <Route path="/tipos-de-paginas-web" element={<PageTypesPricing />} />
            <Route path="/portafolio-paginas" element={<PortfolioPaginas />} />
            <Route path="*" element={<Landing />} />
          </Routes>
          {/* Rendered once here (not per-page) so the widget — and its
              in-memory conversation state — survives navigating between
              routes; mounting it inside each page instead would reset the
              chat on every click to a different page. */}
          {NEXO_ENABLED && <ChatBubble />}
        </BrowserRouter>
        <Toaster
          position="top-center"
          richColors
          toastOptions={{
            style: { fontFamily: "Montserrat, sans-serif" },
          }}
        />
      </div>
    </HelmetProvider>
  );
}

export default App;
